import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Contact.css';
import './Home.css';
import logo from './logo.png';

const ContactEN: React.FC = () => {
  const navigate = useNavigate();
  const [navOpen, setNavOpen] = React.useState(false);
  React.useEffect(() => {
    document.title = 'Contact - Fconnect';
  }, []);
  return (
    <div className="home-page">
      {/* Header (reuse from Home EN) */}
      <header className="home-header">
        <div className="home-container header-inner">
          <div className="brand" onClick={() => { navigate('/en'); setNavOpen(false); } }>
            <img src={logo} alt="Fconnect" />
          </div>
          <button
            className="nav-toggle"
            aria-label={navOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={navOpen}
            aria-controls="main-navigation"
            onClick={() => setNavOpen((o) => !o)}
          >
            {navOpen ? '✕' : '☰'}
          </button>
          <nav id="main-navigation" className={`main-nav ${navOpen ? 'open' : ''}`}>
            <Link to="/en" onClick={() => setNavOpen(false)}>Home</Link>
            <Link to="/en/general-labor" onClick={() => setNavOpen(false)}>General labor</Link>
            <Link to="/en/agricultural-labor" onClick={() => setNavOpen(false)}>Agricultural labor</Link>
            <Link to="/en/healthcare-services" onClick={() => setNavOpen(false)}>Healthcare services</Link>
            <Link to="/en/privacy" onClick={() => setNavOpen(false)}>Privacy Policy</Link>
            <Link to="/en/terms" onClick={() => setNavOpen(false)}>Terms</Link>
            <Link to="/en/contact" onClick={() => setNavOpen(false)}>Contact</Link>
            <Link to="/" className="lang-link" onClick={() => setNavOpen(false)}>Tiếng Việt</Link>
          </nav>
        </div>
      </header>
      <div className={`nav-backdrop ${navOpen ? 'open' : ''}`} onClick={() => setNavOpen(false)} />

      {/* Content */}
      <section className="home-container">
        <header className="contact-header">
          <h1>Contact us</h1>
          <p className="header-subtitle">We are always ready to help</p>
        </header>
        <div className="contact-content">
          <section className="contact-section">
            <h2>Contact information</h2>
            <div className="contact-info-grid">
              <div className="contact-card">
                <div className="contact-icon">
                  <span>📧</span>
                </div>
                <h3>Email</h3>
                <p><strong>trile@taichinh-htp.com</strong></p>
                <p>Respond within 2–4 business hours</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>📞</span>
                </div>
                <h3>Phone</h3>
                <p><strong>02513684266</strong></p>
                <p>Live support 8:00 - 22:00</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>📍</span>
                </div>
                <h3>Address</h3>
                <p><strong>HIEP TIN PHAT FINANCE JOINT STOCK COMPANY</strong></p>
                <p><strong>11/4C, To 15, Kp 6</strong></p>
                <p>Tran Bien Ward</p>
                <p>Dong Nai Province, Vietnam</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>🕐</span>
                </div>
                <h3>Working hours</h3>
                <p><strong>Monday - Sunday</strong></p>
                <p>8:00 - 22:00</p>
                <p>Customer support 24/7</p>
              </div>
            </div>
          </section>
        </div>
      </section>

      {/* Footer (reuse from Home EN) */}
      <footer className="home-footer">
        <div className="home-container footer-inner">
          <div className="footer-contact">
            <p><strong>HIEP TIN PHAT FINANCE JOINT STOCK COMPANY</strong></p>
            <p><strong>Email:</strong> trile@taichinh-htp.com</p>
            <p><strong>Phone:</strong> 02513684266</p>
            <p><strong>Address:</strong> 11/4C, To 15, Kp 6, Tran Bien Ward, Dong Nai Province, Vietnam</p>
            <p><strong>Support hours:</strong> 8:00 - 22:00 (Mon - Sun)</p>
          </div>
          <div className="footer-stores">
            <a className="store-badge small appstore-badge" href="https://apps.apple.com/vn/app/fconnect-htp/id6752923786?l=vi" target="_blank" rel="noopener noreferrer">
              <span className="badge-icon" aria-hidden="true"></span>
              <span className="badge-text"><span className="badge-sub">Download on the</span><span className="badge-brand">App Store</span></span>
            </a>
            <a className="store-badge small play-badge" href="https://play.google.com/store/apps/details?id=com.taichinhhtp.fconnect&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
              <span className="badge-icon" aria-hidden="true">▶</span>
              <span className="badge-text"><span className="badge-sub">GET IT ON</span><span className="badge-brand">Google Play</span></span>
            </a>
          </div>
        </div>
        <div className="copyright">© 2025 Fconnect. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default ContactEN;


